export default __webpack_public_path__ + "static/media/fanghaus-closed.df8881ed.png";